"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _jsxRuntime = require("@emotion/react/jsx-runtime");

var _react = require("@emotion/react");

var _theme = require("@zip/theme");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var SvgCalendar = function SvgCalendar(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  var theme = (0, _react.useTheme)();

  switch (theme.name) {
    case _theme.fearlessBusiness.name:
      return (0, _jsxRuntime.jsxs)("svg", _objectSpread(_objectSpread({
        viewBox: "0 0 60 60",
        fill: "none"
      }, props), {}, {
        children: [title ? (0, _jsxRuntime.jsx)("title", {
          children: title
        }) : null, (0, _jsxRuntime.jsx)("path", {
          d: "M60 30c0 16.569-13.431 30-30 30C13.431 60 0 46.569 0 30 0 13.431 13.431 0 30 0c16.569 0 30 13.431 30 30z",
          fill: "#D0EEFD"
        }), (0, _jsxRuntime.jsx)("rect", {
          x: 14,
          y: 15,
          width: 32,
          height: 31,
          rx: 3,
          fill: "#86D1FF"
        }), (0, _jsxRuntime.jsx)("path", {
          d: "M14 23h32v20a3 3 0 01-3 3H17a3 3 0 01-3-3V23z",
          fill: "#fff"
        }), (0, _jsxRuntime.jsx)("rect", {
          x: 19.767,
          y: 14,
          width: 4.973,
          height: 3.73,
          rx: 1.036,
          fill: "#6EC8FF"
        }), (0, _jsxRuntime.jsx)("rect", {
          x: 34.258,
          y: 14,
          width: 4.973,
          height: 3.73,
          rx: 1.036,
          fill: "#6EC8FF"
        }), (0, _jsxRuntime.jsx)("rect", {
          x: 35,
          y: 26,
          width: 6,
          height: 4,
          rx: 0.518,
          fill: "#F3F1F1"
        }), (0, _jsxRuntime.jsx)("rect", {
          x: 35,
          y: 32,
          width: 6,
          height: 4,
          rx: 0.518,
          fill: "#F3F1F1"
        }), (0, _jsxRuntime.jsx)("rect", {
          x: 35,
          y: 38,
          width: 6,
          height: 4,
          rx: 0.518,
          fill: "#DCF995"
        }), (0, _jsxRuntime.jsx)("rect", {
          x: 27,
          y: 26,
          width: 6,
          height: 4,
          rx: 0.518,
          fill: "#F3F1F1"
        }), (0, _jsxRuntime.jsx)("rect", {
          x: 27,
          y: 32,
          width: 6,
          height: 4,
          rx: 0.518,
          fill: "#F3F1F1"
        }), (0, _jsxRuntime.jsx)("rect", {
          x: 27,
          y: 38,
          width: 6,
          height: 4,
          rx: 0.518,
          fill: "#F3F1F1"
        }), (0, _jsxRuntime.jsx)("rect", {
          x: 19,
          y: 26,
          width: 6,
          height: 4,
          rx: 0.518,
          fill: "#F3F1F1"
        }), (0, _jsxRuntime.jsx)("rect", {
          x: 19,
          y: 32,
          width: 6,
          height: 4,
          rx: 0.518,
          fill: "#F3F1F1"
        }), (0, _jsxRuntime.jsx)("rect", {
          x: 19,
          y: 38,
          width: 6,
          height: 4,
          rx: 0.518,
          fill: "#F3F1F1"
        })]
      }));

    default:
      return (0, _jsxRuntime.jsxs)("svg", _objectSpread(_objectSpread({
        viewBox: "0 0 60 60",
        fill: "none"
      }, props), {}, {
        children: [title ? (0, _jsxRuntime.jsx)("title", {
          children: title
        }) : null, (0, _jsxRuntime.jsx)("path", {
          d: "M60 30c0 16.569-13.431 30-30 30C13.431 60 0 46.569 0 30 0 13.431 13.431 0 30 0c16.569 0 30 13.431 30 30z",
          fill: "#EDE6FF"
        }), (0, _jsxRuntime.jsx)("rect", {
          x: 14,
          y: 15,
          width: 32,
          height: 31,
          rx: 3,
          fill: "#C9B3FF"
        }), (0, _jsxRuntime.jsx)("path", {
          d: "M14 23h32v20a3 3 0 01-3 3H17a3 3 0 01-3-3V23z",
          fill: "#fff"
        }), (0, _jsxRuntime.jsx)("rect", {
          x: 19.767,
          y: 14,
          width: 4.973,
          height: 3.73,
          rx: 1.036,
          fill: "#AA8FFF"
        }), (0, _jsxRuntime.jsx)("rect", {
          x: 34.258,
          y: 14,
          width: 4.973,
          height: 3.73,
          rx: 1.036,
          fill: "#AA8FFF"
        }), (0, _jsxRuntime.jsx)("rect", {
          x: 35,
          y: 26,
          width: 6,
          height: 4,
          rx: 0.518,
          fill: "#F3F1F1"
        }), (0, _jsxRuntime.jsx)("rect", {
          x: 35,
          y: 32,
          width: 6,
          height: 4,
          rx: 0.518,
          fill: "#F3F1F1"
        }), (0, _jsxRuntime.jsx)("rect", {
          x: 35,
          y: 38,
          width: 6,
          height: 4,
          rx: 0.518,
          fill: "#DCF995"
        }), (0, _jsxRuntime.jsx)("rect", {
          x: 27,
          y: 26,
          width: 6,
          height: 4,
          rx: 0.518,
          fill: "#F3F1F1"
        }), (0, _jsxRuntime.jsx)("rect", {
          x: 27,
          y: 32,
          width: 6,
          height: 4,
          rx: 0.518,
          fill: "#F3F1F1"
        }), (0, _jsxRuntime.jsx)("rect", {
          x: 27,
          y: 38,
          width: 6,
          height: 4,
          rx: 0.518,
          fill: "#F3F1F1"
        }), (0, _jsxRuntime.jsx)("rect", {
          x: 19,
          y: 26,
          width: 6,
          height: 4,
          rx: 0.518,
          fill: "#F3F1F1"
        }), (0, _jsxRuntime.jsx)("rect", {
          x: 19,
          y: 32,
          width: 6,
          height: 4,
          rx: 0.518,
          fill: "#F3F1F1"
        }), (0, _jsxRuntime.jsx)("rect", {
          x: 19,
          y: 38,
          width: 6,
          height: 4,
          rx: 0.518,
          fill: "#F3F1F1"
        })]
      }));
  }
};

var _default = SvgCalendar;
exports["default"] = _default;